export { Cdivider, DividerOrientation } from './Cdivider';
export type { CdividerProps } from './Cdivider';

